import { render, staticRenderFns } from "./Acessos_permissoes.vue?vue&type=template&id=5c3f8b70&scoped=true&"
import script from "./Acessos_permissoes.vue?vue&type=script&lang=js&"
export * from "./Acessos_permissoes.vue?vue&type=script&lang=js&"
import style0 from "./Acessos_permissoes.vue?vue&type=style&index=0&id=5c3f8b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f8b70",
  null
  
)

export default component.exports